import React, { useState } from 'react';
import '../App.css';
import logo from '../assets/images/logo.png';
import { useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toast';

const SuperadminLogin = () => {
  const [superadminEmail, setSuperadminEmail] = useState('');
  const [superadminPassword, setSuperadminPassword] = useState('');
  const [targetPhone, setTargetPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();

  async function handleImpersonate(e) {
    e.preventDefault();

    if (!superadminEmail || !superadminPassword || !targetPhone) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    // Clear any previous session data
    localStorage.clear();

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.post(`${baseUrl}/v2/superadmin/impersonate/admin`, {
        superadminEmail: superadminEmail.trim().toLowerCase(),
        superadminPassword,
        targetPhone: targetPhone.trim(),
      });

      if (response.status === 200) {
        const data = response.data;

        // Store the impersonation token and user profile data
        localStorage.setItem('token', data.token);
        localStorage.setItem('tokenTimestamp', Date.now().toString());
        localStorage.setItem('impersonatedBy', data.impersonatedBy);
        localStorage.setItem('impersonationId', data.impersonationId);
        // Store user profile fields needed by dashboard and other pages
        localStorage.setItem('userid', data.userid);
        localStorage.setItem('email', data.email || '');

        toast.success(`Impersonating ${data.targetIdentifier} (${data.userStatus})`);
        setLoading(false);

        // Redirect based on user status
        if (data.userStatus === 'pending') {
          // User is still in registration - go to registration wizard
          history.push('/register-food-scientist-v3');
        } else {
          // User has completed registration - go to dashboard
          history.push('/dashboard');
        }
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      toast.error(error.response?.data?.message || 'Impersonation failed');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="bg-white bg-opacity-70 p-8 rounded-lg shadow-lg w-full max-w-md">
        <img
          src={logo}
          alt="logo"
          className="w-24 mx-auto mb-4"
        />
        <h5 className="text-center text-xl font-semibold mb-2">
          NIGERIAN COUNCIL OF FOOD SCIENCE AND TECHNOLOGY (NiCFoST)
        </h5>

        {/* Superadmin Badge */}
        <div className="flex justify-center mb-4">
          <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider">
            🛡️ Superadmin Access
          </span>
        </div>

        <div className="text-center mb-6">
          <h6 className="text-gray-700 font-medium">Impersonate Food Scientist User</h6>
          <p className="text-sm text-gray-500 mt-1">
            Sign in as any user portal member for debugging purposes.
          </p>
        </div>

        <form onSubmit={handleImpersonate} className="space-y-4">
          {/* Superadmin Credentials Section */}
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 space-y-4">
            <h3 className="text-sm font-semibold text-red-700">Superadmin Credentials</h3>

            <div>
              <label htmlFor="superadminEmail" className="block text-sm font-medium text-gray-700">
                Superadmin Email
              </label>
              <input
                type="email"
                id="superadminEmail"
                required
                placeholder="superdev@nicfost.gov.ng"
                value={superadminEmail}
                onChange={(e) => setSuperadminEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
              />
            </div>

            <div>
              <label htmlFor="superadminPassword" className="block text-sm font-medium text-gray-700">
                Superadmin Password
              </label>
              <div className="relative mt-1">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="superadminPassword"
                  required
                  placeholder="Enter superadmin password"
                  value={superadminPassword}
                  onChange={(e) => setSuperadminPassword(e.target.value)}
                  className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>
          </div>

          {/* Target User Section */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-blue-700 mb-3">Target User</h3>

            <div>
              <label htmlFor="targetPhone" className="block text-sm font-medium text-gray-700">
                Food Scientist Phone Number
              </label>
              <input
                type="text"
                id="targetPhone"
                required
                placeholder="e.g., 9137999312 (without leading 0)"
                value={targetPhone}
                onChange={(e) => setTargetPhone(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">
                Enter phone number without leading zero
              </p>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 rounded-lg text-white font-medium ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
            } transition-colors`}
          >
            {loading ? 'Impersonating...' : 'Impersonate User'}
          </button>

          {/* Footer Links */}
          <div className="text-center pt-4 border-t border-gray-200">
            <Link to="/login" className="text-green-600 hover:text-green-700 underline text-sm">
              Back to regular login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperadminLogin;
